export class SchoolGradeUtil {
    /**
     * 年度を取得する
     * @param {Date} date 対象の日付
     * @return {Number}
     */
    static getSchoolYear(date) {
        if (date.getMonth() >= 3) {
            return date.getFullYear()
        } else {
            return date.getFullYear() - 1
        }
    }

    /**
     * 生年月日から dateTreatedAsCurrent 時点での中学何年生かを取得する
     * @param {Date} birthDate 生年月日
     * @param {Date} dateTreatedAsCurrent いつの時点での学年を判定するか指定する
     * @return {Number | null}
     * 中学1年 13
     * 中学2年 14
     * 中学3年 15
     * その他 null
     */
    static getJhsGrade(birthDate, dateTreatedAsCurrent) {
        const schoolLevel = this.getSchoolGrade(birthDate, dateTreatedAsCurrent)
        if (schoolLevel >= 13 && schoolLevel <= 15) {
            return schoolLevel
        } else {
            return null;
        }
    }

    /**
     * 生年月日から dateTreatedAsCurrent 時点での学年を算出する
     * 早生まれ → 現在年度 - 生まれた年 + 1 = 学年
     * 早生まれでない → 現在年度 - 生まれた年 = 学年
     * 6 ~ 12：小学生、13 ~ 15：中学生、16 ~ 18：高校生
     * @param {Date} birthDate 生年月日
     * @param {Date} dateTreatedAsCurrent いつの時点での学年を判定するか指定する
     * @return {Number}
     */
    static getSchoolGrade(birthDate, dateTreatedAsCurrent) {
        const currentSchoolYear = this.getSchoolYear(dateTreatedAsCurrent)

        if (this.isBornEarly(birthDate)) {
            return currentSchoolYear - birthDate.getFullYear() + 1
        } else {
            return currentSchoolYear - birthDate.getFullYear()
        }
    }

    /**
     * 生年月日から早生まれかどうかを判定する(1月1日~4月1日)
     * @param {Date} birthDate
     * @returns {boolean}
     */
    static isBornEarly(birthDate) {
        return birthDate.getMonth() <= 2 || (birthDate.getMonth() === 3 && birthDate.getDate() === 1);
    }

    /**
     * 学年リストを取得する
     * @returns {[]}
     */
    static getGradeList() {
        return [
            {id: 13, label:'中1'},
            {id: 14, label:'中2'},
            {id: 15, label:'中3'},
        ]
    }

    /**
     * 生年月日から学年を取得し、指定された学年（中1、中2、中3）と一致するかを判定する
     * @param {Date} birthDate
     * @param {Date} dateTreatedAsCurrent
     * @param {String} gradeLabel
     * @returns {boolean}
     */
    static isMatchingGrade(birthDate, dateTreatedAsCurrent, gradeLabel) {
        let grade = SchoolGradeUtil.getGradeList().find((option) => {
            return option.label === gradeLabel;
        }).id;

        return this.getJhsGrade(birthDate, dateTreatedAsCurrent) === grade
    }
}
